module.exports = __webpack_public_path__ + "media/images/jira_logo_icon-02f8e94c.svg";